// Auto-remove flash messages after 10 seconds
function removeMessage() {
  const messageContainer = document.querySelector('#flash')
  if (messageContainer) {
    messageContainer.classList.add('flash-hidden')
    setTimeout(() => {
      messageContainer.remove()
    }, 3000)
  }
}

// Re-bind on each page load (Turbo-compatible)
document.addEventListener('turbo:load', function() {
  const flash = document.querySelector('#flash')
  if (flash) {
    setTimeout(removeMessage, 10000)
  }
})

// Also run on initial page load (non-Turbo)
if (document.querySelector('#flash')) {
  setTimeout(removeMessage, 10000)
}
